import InfoIcon from 'components/ReusableComponents/Icons/Info'

import styles from './InfoBar.module.scss'

const InfoBar = ({ marginBottom = 0, marginTop = 25, text }) => {
  return (
    <div className={styles.bar} style={{ marginBottom, marginTop }}>
      <div className={styles.iconHolder}>
        <InfoIcon />
      </div>
      <div className={styles.textHolder}>
        <p className={styles.title}>{text}</p>
      </div>
    </div>
  )
}

export default InfoBar
